import React from "react";
import ModuleFilterMenu from "./ModuleFilterMenu";
import ModuleRadioOption from "./ModuleRadioOption";

const ModuleSortMenu = ({
  open,
  onToggle,
  onClose,
  sortBy,
  sortOrder,
  options,
  onChangeSortBy,
  onChangeSortOrder,
  descLabel = "Descending",
  ascLabel = "Ascending",
}) => (
  <ModuleFilterMenu
    open={open}
    onToggle={onToggle}
    onClose={onClose}
    label="Sort"
    icon="ph:sort-ascending"
    eyebrow="Order results"
    title="Sort"
    columns={2}
    size="narrow"
    ariaLabel="Sort results"
  >
    <fieldset>
      <legend>Sort by</legend>
      {options.map((option) => (
        <ModuleRadioOption
          key={option.value}
          name="module-sort-by"
          checked={sortBy === option.value}
          onChange={() => onChangeSortBy(option.value)}
          plain
        >
          {option.label}
        </ModuleRadioOption>
      ))}
    </fieldset>
    <fieldset>
      <legend>Order</legend>
      <ModuleRadioOption
        name="module-sort-order"
        checked={sortOrder === "desc"}
        onChange={() => onChangeSortOrder("desc")}
        plain
      >
        {descLabel}
      </ModuleRadioOption>
      <ModuleRadioOption
        name="module-sort-order"
        checked={sortOrder === "asc"}
        onChange={() => onChangeSortOrder("asc")}
        plain
      >
        {ascLabel}
      </ModuleRadioOption>
    </fieldset>
  </ModuleFilterMenu>
);

export default ModuleSortMenu;
